export type DeviceType = 'mobile' | 'tablet' | 'desktop';
export type BrowserName = 'chrome' | 'safari' | 'firefox' | 'edge' | 'samsung' | 'other';
export type OsName = 'ios' | 'android' | 'mac' | 'windows' | 'linux' | 'chrome_os' | 'other';

/**
 * Classify device class from `navigator.userAgent`.
 * Tablet before mobile so Android tablets (no "Mobile") and iPads are not lumped in as phones.
 */
export function getDeviceType(userAgent: string = navigator.userAgent): DeviceType {
  const ua = userAgent;
  if (/iPad|Tablet/i.test(ua) || (/Android/i.test(ua) && !/Mobile/i.test(ua))) {
    return 'tablet';
  }
  if (/Mobi|iPhone|iPod|Android/i.test(ua)) {
    return 'mobile';
  }
  return 'desktop';
}

/**
 * Classify browser from UA. Order matters: Edge/Samsung/Firefox before Chrome;
 * Safari is "Safari without Chrome/Chromium".
 */
export function getBrowser(userAgent: string = navigator.userAgent): BrowserName {
  const ua = userAgent;
  if (/Edg(?:e|A|iOS)?\//i.test(ua)) return 'edge';
  if (/SamsungBrowser/i.test(ua)) return 'samsung';
  if (/Firefox|FxiOS/i.test(ua)) return 'firefox';
  if (/Chrome|CriOS|Chromium/i.test(ua)) return 'chrome';
  if (/Safari/i.test(ua)) return 'safari';
  return 'other';
}

/**
 * Classify OS from UA. iPad/iPhone/iPod → ios before Macintosh (iPadOS can look Mac-like).
 */
export function getOs(userAgent: string = navigator.userAgent): OsName {
  const ua = userAgent;
  if (/iPhone|iPod|iPad/i.test(ua)) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  if (/CrOS/i.test(ua)) return 'chrome_os';
  if (/Windows/i.test(ua)) return 'windows';
  if (/Mac OS X|Macintosh/i.test(ua)) return 'mac';
  if (/Linux/i.test(ua)) return 'linux';
  return 'other';
}
